import {
    Boxes,
    Store,
    PackageCheck,
    Briefcase,
    Repeat,
    ArrowUpRight,
} from "lucide-react";

const SERVICES_IMG =
    "https://customer-assets.emergentagent.com/job_creaciones-pro/artifacts/fy9uatac_logistica-robusta.webp";

const services = [
    {
        icon: Boxes,
        title: "Comercialización Mayorista de Suministros",
        description:
            "Gestionamos ventas por volumen de artículos de oficina y papelería, implementando procesos de surtido masivo y logística de distribución directa para empresas e instituciones.",
        accent: "#f4861c",
    },
    {
        icon: Store,
        title: "Comercio al por Menor Especializado",
        description:
            "Operamos puntos de venta directa con atención personalizada, donde aplicamos procesos de selección de stock curado para satisfacer las necesidades inmediatas del consumidor final.",
        accent: "#ea4d87",
    },
    {
        icon: PackageCheck,
        title: "Distribución y Abasto de Papelería",
        description:
            "Ejecutamos el flujo comercial de materiales escolares y técnicos, desde la recepción de grandes lotes hasta su colocación en anaquel o entrega programada a minoristas.",
        accent: "#f49c8b",
    },
    {
        icon: Briefcase,
        title: "Venta Corporativa de Equipamiento de Oficina",
        description:
            "Proceso de comercialización enfocado en mobiliario y consumibles técnicos, incluyendo servicios de cotización por volumen y gestión de cuentas empresariales.",
        accent: "#f4861c",
    },
    {
        icon: Repeat,
        title: "Gestión de Inventarios y Suministro Continuo",
        description:
            "Servicio de resurtido automático y ventas por catálogo que asegura que nuestros clientes de mayoreo nunca pierdan la continuidad operativa por falta de insumos.",
        accent: "#ea4d87",
    },
];

export default function Services() {
    return (
        <section
            id="servicios"
            data-testid="services-section"
            className="py-20 lg:py-32 opteris-soft-bg relative overflow-hidden"
        >
            <div className="absolute top-40 -right-40 w-96 h-96 rounded-full bg-[#f49c8b]/20 blur-3xl pointer-events-none" />

            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
                <div className="max-w-3xl fade-up">
                    <span className="opteris-chip">
                        Productos y Servicios
                    </span>
                    <h2
                        data-testid="services-heading"
                        className="font-display font-black text-3xl sm:text-4xl lg:text-5xl tracking-tight mt-5 leading-[1.1]"
                    >
                        Nuestros{" "}
                        <span className="opteris-gradient-text">
                            productos y servicios
                        </span>
                    </h2>
                    <p className="mt-5 text-gray-600 leading-relaxed text-base sm:text-lg max-w-2xl">
                        Soluciones integrales de papelería y oficina para
                        empresas, instituciones educativas y consumidor final.
                    </p>
                </div>

                <div className="mt-16 grid md:grid-cols-8 lg:grid-cols-12 gap-6">
                    {/* Featured image card */}
                    <div className="md:col-span-8 lg:col-span-5 fade-up">
                        <div className="relative rounded-[1.75rem] overflow-hidden h-full min-h-[320px] border border-gray-100">
                            <img
                                src={SERVICES_IMG}
                                alt="Logística y mayoreo"
                                className="absolute inset-0 w-full h-full object-cover"
                            />
                            <div className="absolute inset-0 bg-gradient-to-tr from-[#1a1a1a]/80 via-[#1a1a1a]/30 to-transparent" />
                            <div className="relative z-10 p-8 lg:p-10 flex flex-col justify-end h-full min-h-[320px]">
                                <span className="opteris-chip bg-white/20 !text-white !border-white/30">
                                    Logística robusta
                                </span>
                                <h3 className="text-white font-display font-black text-2xl sm:text-3xl mt-4 leading-tight max-w-xs">
                                    Del almacén a tus manos, sin falla.
                                </h3>
                                <p className="text-white/80 mt-3 text-sm max-w-sm">
                                    Operamos con procesos de distribución
                                    directa para empresas, instituciones y
                                    consumidor final.
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* Service cards */}
                    {services.map((s, i) => (
                        <ServiceCard
                            key={i}
                            index={i}
                            Icon={s.icon}
                            title={s.title}
                            description={s.description}
                            accent={s.accent}
                        />
                    ))}
                </div>
            </div>
        </section>
    );
}

function ServiceCard({ index, Icon, title, description, accent }) {
    // First service spans more, others are compact
    const span =
        index === 0
            ? "md:col-span-8 lg:col-span-7"
            : index === 1 || index === 2
              ? "md:col-span-4 lg:col-span-6"
              : "md:col-span-4 lg:col-span-6";

    return (
        <div
            data-testid={`service-card-${index}`}
            className={`opteris-card p-7 lg:p-8 ${span} fade-up`}
        >
            <div className="flex items-start justify-between">
                <div
                    className="w-12 h-12 rounded-xl flex items-center justify-center"
                    style={{
                        background: `${accent}15`,
                        color: accent,
                    }}
                >
                    <Icon size={22} />
                </div>
                <ArrowUpRight
                    size={18}
                    className="text-gray-300 group-hover:text-[#ea4d87]"
                />
            </div>
            <h3 className="font-display font-bold text-lg sm:text-xl mt-5 tracking-tight leading-snug">
                {title}
            </h3>
            <p className="mt-3 text-sm text-gray-600 leading-relaxed">
                {description}
            </p>
        </div>
    );
}
